import * as yup from 'yup';

export const schema = yup.object({
  checkIn: yup.date().label('Check-in').required(),
  checkOut: yup.date().label('Check-out').required(),
  phoneNumber: yup.string().label('Phone number').trim().required().max(40),
  email: yup.string().label('Email address').email().trim().required().max(255),
});
